import { render, staticRenderFns } from "./CeldaCorreo.vue?vue&type=template&id=a8e5ef46&scoped=true"
import script from "./CeldaCorreo.vue?vue&type=script&lang=js"
export * from "./CeldaCorreo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e5ef46",
  null
  
)

export default component.exports